import { formsService, isDateNowGreater, sessionService } from ".";
import { LOGIN_FAIL } from "../errors";
import SectionInstance from "../Model/SectionInstance";
export class FormInstancesService {
    constructor(apiService, queryParamsFactory, instancesFactory, formMembersFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
        this.instancesFactory = instancesFactory;
        this.formMembersFactory = formMembersFactory;
    }
    async getInstance(instanceId) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        console.log(instanceId);
        if (hasNetwork) {
            try {
                const response = await this.apiService.get(`instance/${instanceId}`);
                if (!response.ok) {
                    throw new Error('Ha ocurrido un error al obtener la instancia de formulario.');
                }
                const content = await response.json();
                if (!isDateNowGreater(new Date(content.dateCreated).getTime().toString(), 2)) {
                }
                const dataString = JSON.stringify(content);
                localStorage.setItem(`${instanceId}`, dataString);
                return this.createFormInstance(content);
            }
            catch (error) {
                console.log(error);
                return null;
            }
        }
        const instance = JSON.parse(localStorage.getItem(`${instanceId}`));
        if (!instance) {
            throw new Error('Ha ocurrido un error al obtener la instancia de formulario.');
        }
        if (instance.sections) {
            return this.createFormInstance(instance);
        }
        return this.createLiteFormInstance(instance);
    }
    async queryInstances(query) {
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`instance/query?${params}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al realizar la consulta de instancias.');
        }
        const content = await response.json();
        return content.map(data => this.createFormInstance(data));
    }
    async getUserInstances() {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get('user/instances');
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener las instancias del usuario.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`userInstances`, dataString);
            return content.map(data => this.createFormInstance(data));
        }
        const instances = JSON.parse(localStorage.getItem(`userInstances`));
        if (!instances || instances.length === 0) {
            throw new Error('Ha ocurrido un error al obtener las instancias del usuario.');
        }
        console.log('Cache INSTANCES');
        return instances.map(data => this.createFormInstance(data));
    }
    async getOfflineInstace(instanceId) {
        const instance = JSON.parse(localStorage.getItem(`${instanceId}`));
        if (!instance) {
            return null;
        }
        if (instance.sections) {
            return this.createFormInstance(instance);
        }
        return this.createLiteFormInstance(instance);
    }
    async createInstance(instance) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        const owner = instance.members.find(({ isOwner }) => isOwner);
        if (!owner) {
            throw new Error('No se ha establecido el propietario del formulario.');
        }
        if (hasNetwork) {
            try {
                const response = await this.apiService.post(`instance`, {
                    id: instance.id,
                    formId: instance.formId,
                    dateCreated: instance.dateCreated,
                    ownerId: owner.userId,
                });
                if (!response.ok) {
                    throw new Error('Ha ocurrido un error al guardar la instancia de formualrio.');
                }
                return true;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        }
        const forms = JSON.parse(localStorage.getItem(`formsQuerys`));
        const form = forms.results.find(form => form.id === instance.formId);
        if (!form) {
            return false;
        }
        console.log(instance);
        formsService.createLocalStorageForm(JSON.parse(localStorage.getItem(`${instance.formId}`)));
        const instaceOffLine = this.createFormInstance({
            id: instance.id,
            formId: instance.formId,
            isFinished: false,
            sections: form._sections,
            dateCreated: new Date().getTime(),
            members: instance.members
        });
        localStorage.setItem(`instanceOffline`, instance.id);
        localStorage.setItem(`${instance.id}`, JSON.stringify(instaceOffLine));
        const answers = form._answer;
        localStorage.setItem(`answer-${instance.id}`, JSON.stringify(answers));
        return true;
    }
    async createOffLineInstance(instance) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        const owner = instance.members.find(({ isOwner }) => isOwner);
        if (!owner) {
            throw new Error('No se ha establecido el propietario del formulario.');
        }
        if (!hasNetwork) {
            try {
                const response = await this.apiService.post(`instance`, {
                    id: instance.id,
                    formId: instance.formId,
                    dateCreated: instance.dateCreated,
                    ownerId: owner.userId,
                    noAnswer: true
                });
                if (!response.ok) {
                    throw new Error('Ha ocurrido un error al guardar la instancia de formualrio.');
                }
                return true;
            }
            catch (error) {
                console.log(error);
            }
        }
    }
    async removeInstance(instanceId) {
        const response = await this.apiService.delete(`instance/${instanceId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar la instancia de formualrio.');
        }
    }
    async addMember(instanceId, userId) {
        const response = await this.apiService.post(`instance/${instanceId}/member`, { userId });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al añadir al miembro de la instancia de formualrio.');
        }
    }
    async quitMember(instanceId, userId) {
        const response = await this.apiService.delete(`instance/${instanceId}/member/${userId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al quitar al miembro de la instancia de formualrio.');
        }
    }
    async buddyPartner(instance) {
        const instanceId = instance.id.valueOf();
        const response = await this.apiService.post(`instance/${instanceId}/buddy`, { instanceId });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al quitar al miembro de la instancia de formualrio.');
        }
        const content = await response.json();
        const members = content.map((data) => this.createFormMember(instance, {
            userId: data.userId.value,
            isOwner: data.isOwner.value,
            isSigned: data._isSigned.value,
            signDate: data._signDate.value,
            buddyId: data._buddyId.value
        }));
        return members;
    }
    async setSectionInstanceRequiredState(instanceId, sectionId, required) {
        const response = await this.apiService.put(`instance/${instanceId}/section/${sectionId}/set-required`, {
            required
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al establecer el estado de la instancia de seción.');
        }
    }
    async signInstance(instanceId, userId, blob) {
        const formData = new FormData();
        formData.set('instanceId', instanceId);
        formData.set('userId', userId);
        formData.set('file', blob);
        const response = await this.apiService.post(`instance/${instanceId}/sign`, formData);
        if (!response.ok) {
            const error = new Error('La autenticación no es correcta.');
            error.name = LOGIN_FAIL;
            throw error;
        }
    }
    async unsingInstance(instanceId, userId) {
        const response = await this.apiService.get(`instance/${instanceId}/unsign/${userId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar la firma del formulario.');
        }
    }
    async removeSignatures(instanceId) {
        const response = await this.apiService.get(`instance/${instanceId}/unsign`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar las firmas del formulario.');
        }
    }
    async finalize(instanceId, dateCompleted) {
        const response = await this.apiService.post(`instance/${instanceId}/finish`, {
            dateCompleted
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al finalizar el formulario.');
        }
    }
    async getUserHistoric(offset, limit) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`user/historic/${offset}/${limit}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener el historial del usuario.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`userInstancesHistoric`, dataString);
            return content.map(data => this.createFormInstance(data));
        }
        const instances = JSON.parse(localStorage.getItem(`userInstancesHistoric`));
        if (!instances || instances.length === 0) {
            throw new Error('Ha ocurrido un error al obtener el historial del usuario.');
        }
        console.log('Cache INSTANCES');
        return instances.map(instance => this.createFormInstance(instance));
    }
    createFormInstance(data) {
        const sections = data.sections.map((dto) => { var _a; return [dto, ...(((_a = dto.questions) === null || _a === void 0 ? void 0 : _a.map(({ sections }) => sections)) || [])]; }).flat(Infinity);
        const instance = this.instancesFactory.createFormInstance(data.formId, data.id, sections.map((sectionInstanceDto) => this.createSectionInstance(sectionInstanceDto)), data.isFinished, new Date(data.dateCreated), data.dateCompleted ? new Date(data.dateCompleted) : null);
        const members = data.members.map((data) => this.createFormMember(instance, data));
        for (const member of members) {
            instance.addMember(member);
        }
        return instance;
    }
    createFormMember(instance, { userId, isOwner, isSigned, signDate, buddyId }) {
        return this.formMembersFactory.createFormMember(instance, userId, isOwner, isSigned, signDate ? new Date(signDate) : null, buddyId ? buddyId : null);
    }
    createSectionInstance(dto) {
        return new SectionInstance(dto.sectionId, dto.required);
    }
    createLiteSectionInstance(dto) {
        return new SectionInstance(dto.id, dto.required);
    }
    createLiteFormInstance(data) {
        const forms = JSON.parse(localStorage.getItem('formsQuerys'));
        const form = forms.results.find(f => f.id === data.formId);
        const user = sessionService.user;
        if (!form || !user) {
            throw new Error('Ha ocurrido un error al obtener la instancia.');
        }
        const sections = form._sections.map((dto) => { var _a; return [dto, ...(((_a = dto.questions) === null || _a === void 0 ? void 0 : _a.map(({ sections }) => sections)) || [])]; }).flat(Infinity);
        const instance = this.instancesFactory.createFormInstance(data.formId, data.id, sections.map((sectionInstanceDto) => this.createLiteSectionInstance(sectionInstanceDto)), data.isFinished, new Date(data.dateCreated), data.dateCompleted ? new Date(data.dateCompleted) : null);
        const members = data.members.map((data) => this.createFormMember(instance, data));
        for (const member of members) {
            instance.addMember(member);
        }
        return instance;
    }
}
